export default __webpack_public_path__ + "static/media/icon.e707e3e3.png";